import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

export const RadioContext = React.createContext({
  onRadioChange: () => {},
  selected: null
})

const FieldSet = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`

class RadioGroup extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    Container: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    name: PropTypes.string.isRequired,
    controlled: PropTypes.bool,
    backgroundColor: PropTypes.string
  }

  static defaultProps = {
    onChange: () => {},
    Container: FieldSet,
    controlled: false
  }

  static getDerivedStateFromProps (nextProps) {
    if (nextProps.controlled) {
      return {
        selected: nextProps.selected
      }
    }
    return null
  }

  constructor (props) {
    super(props)
    this.state = {
      name: props.name,
      onRadioChange: this.onRadioChange,
      selected: props.selected
    }
  }

  onRadioChange = (value) => {
    const { name, onChange, controlled } = this.props
    if (controlled) {
      onChange(name, value)
    } else {
      this.setState({ selected: value }, onChange.bind(null, name, value))
    }
  }

  render () {
    const { name, children, Container, backgroundColor } = this.props

    return (
      <Container name={name} backgroundColor={backgroundColor}>
        <RadioContext.Provider value={this.state}>
          {children}
        </RadioContext.Provider>
      </Container>
    )
  }
}

export default RadioGroup
